import React from "react";
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
  containerVariants,
  itemVariants,
  photoVariants,
} from "../../variants/variants";
const Section4 = () => {
  const { t } = useTranslation();
  
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      exit="exit"
      variants={containerVariants}
      className="min-h-[83vh]  w-full  relative mt-28"
    >
      <motion.img
        initial="initial"
        whileInView="whileInView"
        exit="exit"
        variants={photoVariants}
        src="/images/sustainability/leaf.jpg"
        className="object-cover h-full w-full object-center absolute top-0 left-0"
      />

      <motion.div
        initial="initial"
        whileInView="whileInView"
        exit="exit"
        variants={photoVariants}
        className="h-full w-full bg-[#98920E] mix-blend-multiply absolute top-0 left-0"
      ></motion.div>

      <div className="grid grid-cols-10   w-full relative z-50 py-28 ">
        <div className=" col-start-2 md:col-start-2 col-span-8 md:col-span-6 w-full ">
          <motion.h5
            variants={itemVariants}
            className=" text-65 text-white mb-5"
          >
            {t("sustainability.cleanProduction.title")}
            <br />
            <span className="font-bold">{t("sustainability.cleanProduction.subtitle")}</span>
          </motion.h5>

          <motion.p
            variants={itemVariants}
            className="text-white text-20 font-medium mb-10"
          >
            {t("sustainability.cleanProduction.description")}
          </motion.p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4  space-y-5 md::space-y-0">
            <div>
              <motion.h5
                variants={itemVariants}
                className="text-white text-25 leading-relaxed font-light"
              >
                {t("sustainability.cleanProduction.stat1")}
                <br />
                <span className="text-38 font-bold">{t("sustainability.cleanProduction.stat1Value")}</span>
              </motion.h5>
            </div>

            <div className="md:!mt-0">
              <motion.h5
                variants={itemVariants}
                className="text-white text-25 leading-relaxed font-light"
              >
                {t("sustainability.cleanProduction.stat2")}
                &nbsp;
                <span className="text-38 font-bold">{t("sustainability.cleanProduction.stat2Value")}</span>
                <br />
                {t("sustainability.cleanProduction.stat2Text")}
              </motion.h5>
            </div>

            <div className="lg:!mt-0">
              <motion.h5
                variants={itemVariants}
                className="text-white text-25 leading-relaxed font-light"
              >
                {t("sustainability.cleanProduction.stat3")}
                <br />
                <span className="text-38 font-bold">{t("sustainability.cleanProduction.stat3Value")}</span>
                &nbsp; {t("sustainability.cleanProduction.stat3Text")}
              </motion.h5>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Section4;
